/**
 * App SDK 方法枚举
 * @description App SDK 通信方法定义
 */
export enum EAppCommunicationFuncName {
  /**
   * 接收应用内网页通用功能
   */
  RECEIVE_IN_APP_WEB_COMMON_FUNC = 'ReceiveInAppWebCommonFunc',

  /**
   * 商品试戴
   */
  PRODUCT_TRY_ON = 'ProductTryOn',

  /**
   * 跳转商品详情
   */
  JUMP_GOODS_DETAIL = 'jumpGoodsDetail',

  /**
   * 跳转商品列表
   */
  JUMP_GOODS_LIST = 'jumpGoodsList',

  /**
   * 显示对话框
   */
  SHOW_DIALOG = 'ShowDialog',

  /**
   * 刷新账户信息
   */
  REFRESH_ACCOUNT_INFO = 'RefreshAccountInfo',

  /**
   * 跳转到页面
   */
  JUMP_TO_PAGE = 'JumpToPage',

  /**
   * 全屏显示
   */
  FULL_SCREEN_SHOW = 'FullScreenShow',

  /**
   * 运行JS函数
   */
  RUN_JS_FUNCTION = 'runJSFunction',

  /**
   * 其他方法
   */
  OTHER_METHOD = 'OtherMethod',

  /**
   * 在线客服
   */
  LIVECHAT = 'livechat',

  /**
   * 发送邮件
   */
  SEND_EMAIL = 'SendEmail',

  /**
   * 拨打电话
   */
  CALL_MOBILE = 'CallMobile',

  /**
   * 在线聊天
   */
  ONLINE_CHAT = 'OnLineChat',

  /**
   * 外部启动URL
   */
  EXTERNAL_LAUNCH_URL = 'ExternalLaunchUrl',

  /**
   * 下载文件
   */
  DOWNLOAD_FILE = 'DownloadFile',

  /**
   * 选择图片
   */
  CHOOSE_PIC = 'ChoosePic',

  /**
   * 关闭网页视图
   */
  CLOSE_WEB_VIEW = 'CloseWebView',

  /**
   * 问题提交
   */
  QUESTION_SUBMIT = 'QuestionSubmit',

  /**
   * 问卷提交
   */
  QUESTIONNAIRE_SUBMIT = 'questionnaireSubmit',

  /**
   * 问题提交错误
   */
  QUESTION_SUBMIT_ERROR = 'QuestionSubmitError',

  /**
   * 活动分享
   */
  ACTIVITY_SHARE = 'ActivityShare',

  /**
   * 支持分享渠道列表
   */
  SUPPORT_SHARE_CHANNEL_LIST = 'SupportShareChannelList',

  /**
   * Apple iOS 13及以上
   */
  APPLE_IOS_13_UP = 'AppleiOS13UP',

  /**
   * 第三方登录方法
   */
  THIRD_LOGIN_METHOD = 'ThirdLoginMethod',

  /**
   * 商品收藏方法
   */
  PRODUCT_WISH_METHOD = 'ProductWishMethod',

  /**
   * 应用登录成功
   */
  APP_LOGIN_SUCCESS = 'apploginSuccess',

  /**
   * 应用上传完成
   */
  APP_UPLOAD_COMPLETE = 'appUploadComplete',

  /**
   * 应用收藏数据
   */
  APP_WISH_DATA = 'appWishData',

  /**
   * 页面访问记录
   */
  WEB_PAGE_INFO = 'ReceiveWebPageInfo',
  /**
   * 在 APP 中当前 H5 是否可见
   */
  WEB_VIEW_VISIBILITY = 'WebViewVisibility',
}
